import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

const COOKIE_NAME = "duro_top_announcement_dismissed";
const COOKIE_EXPIRES_IN_DAYS = 7;

const TopAnnouncementBar = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(() => !Cookies.get(COOKIE_NAME));

  useEffect(() => {
    const { body } = document;

    if (!body) {
      return undefined;
    }

    if (isVisible) {
      body.classList.add("top-announcement-visible");
    } else {
      body.classList.remove("top-announcement-visible");
    }

    return () => {
      body.classList.remove("top-announcement-visible");
    };
  }, [isVisible]);

  const handleClose = () => {
    Cookies.set(COOKIE_NAME, "true", {
      expires: COOKIE_EXPIRES_IN_DAYS,
      path: "/",
    });
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  const linkUrl = t("topAnnouncement.linkUrl");
  const linkText = t("topAnnouncement.linkText");

  return (
    <div className="top-announcement-bar">
      <span className="top-announcement-message">
        {t("topAnnouncement.message")}{" "}
        <a href={linkUrl} target="_blank" rel="noopener noreferrer">
          {linkText}
        </a>
      </span>
      <button
        type="button"
        className="top-announcement-close"
        onClick={handleClose}
        aria-label={t("topAnnouncement.closeLabel")}
      >
        &times;
      </button>
    </div>
  );
};

export default TopAnnouncementBar;

